 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

"use strict";

/**
 * Debounce function for rate limiting a function.
 *
 * It prevents a function from being fired too frequently. This is useful
 * for resource intensive processes like resize event handlers and tap/click
 * handlers.
 *
 *
 * @see: https://davidwalsh.name/javascript-debounce-function
 *
 * @param function func - the callback function
 * @param int wait - the time to wait in milliseconds
 * @param bool immediate - call the function immediately
 *
 * @return function - the modified function that will only run once within a wait period.
 */
function debounce(func, wait, immediate) {
  var timeout;
  if (!wait) {
    console.warn("Debounce was called without a 'wait' argument. This renders debounce almost completely ineffective.");
  }
  return function () {
    var context = this,
      args = arguments;
    var later = function later() {
      timeout = null;
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  };
}
;

/**
 * Debounce scroll event for rate limiting scroll events.
 *
 * Putting events on the scroll handler should usually be discouraged
 * as they can be fired very frequently and this can cause the browser
 * to lag.
 *
 * Instead, use this event: debounceScroll
 *
 * This allows us to have only one scoll event handler that triggers
 * the debounceScoll event (on the window) 50ms (or whatever the
 * delay_time is set) after a scroll event starts and then stops.
 *
 *
 * @see: http://ejohn.org/blog/learning-from-twitter/#postcomment
 * (particularly read the comments for this variant)
 *
 * @usage:
 *
 *  	window.addEventListener( 'debounceScroll', function() {
 *  		console.log( 'scrolled....');
 *  	}, false );
 */
var debounceScroll = create_event('debounceScroll');
window.addEventListener('load', function () {
  var delay_time = 50;
  var delay_start = 0;
  var last_scroll_pos = 0;
  function scroll() {
    // If we are already scrolling, reset the delay
    if (delay_start) {
      clearTimeout(delay_start);
    }

    // Are we scrolling down?
    var scrollDown = window.pageYOffset > last_scroll_pos;
    last_scroll_pos = window.pageYOffset; // Save for next time

    delay_start = setTimeout(function (event) {
      debounceScroll.scrollDown = scrollDown;
      window.dispatchEvent(debounceScroll);
    }, delay_time);
  }

  // For momentum-scrolling touch devices that only trigger a scroll event on scroll-end
  if ('touchmove' in document.documentElement) {
    window.addEventListener('touchmove', function () {
      scroll();
    });
  } else {
    // Non-touch devices
    window.addEventListener('scroll', function () {
      scroll();
    });
  }
});
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

"use strict";

/**
* @file cookie.js
* Generic cookie handling functions.
* @author Hal Burgiss 2009-03-22
*/
function setCookie(name, value, days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "; expires=" + date.toGMTString();
  } else var expires = "";
  document.cookie = name + "=" + value + expires + "; path=/";
}
function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
function eraseCookie(name) {
  setCookie(name, "", -1);
}
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

"use strict";

/**
 * Slate Mobile Navigation Menu
 *
 */
(function () {
  'use strict';

  /**
   * 'is_mobile' variable to determine if this is a mobile size.
   */
  var set_is_mobile,
    is_mobile = false;
  window.addEventListener('load', function () {
    var menuToggle = document.getElementById('menu-toggle');
    var mainMenuToggle = document.getElementById('main-menu-toggle');
    var subToggles = document.querySelectorAll('.submenu-toggle');
    (set_is_mobile = function set_is_mobile() {
      if (window.getComputedStyle(menuToggle).display === "none") {
        is_mobile = false;
      } else {
        is_mobile = true;
      }
    })();

    // Function to close the menu
    function closeMenu(button) {
      var submenu = button.parentElement.querySelector('.menu__submenu');
      submenu.style.opacity = '0';
      submenu.style.transition = 'opacity .25s ease-in-out, visibility .25s ease-in-out';
      submenu.style.visibility = 'hidden';
      button.classList.remove('open');
      button.parentNode.classList.remove('open');
      button.parentNode.parentNode.classList.remove('open');
      button.setAttribute('aria-expanded', false);
    }

    /**
     * Toggle menu open/closed when clicking menu toggle
     */
    menuToggle.addEventListener('click', function () {
      this.classList.toggle('open');
      document.getElementById('menu').classList.toggle('open');
      document.querySelector('body').classList.toggle('opened-menu');
      if (this.classList.contains('open')) {
        this.setAttribute('aria-expanded', true);
      } else {
        this.setAttribute('aria-expanded', false);
      }

      // document.querySelector('.main-menu .menu').classList.remove('open');
      var toggles = document.querySelectorAll('.main-menu .submenu-toggle.open');
      toggles.forEach(function (element) {
        element.classList.remove('open');
      });
    });

    /**
     * Toggle sub-menu visibility
     */
    mainMenuToggle.addEventListener('click', function () {
      this.classList.remove('open');
      menuToggle.style.display = 'block';
      document.querySelector('.main-menu .menu').classList.remove('open');
      var toggles = document.querySelectorAll('.main-menu .submenu-toggle.open');
      toggles.forEach(function (element) {
        element.classList.remove('open');
        element.nextElementSibling.style.maxHeight = '0px';
      });
      var submenus = document.querySelectorAll('.menu__submenu');
      submenus.forEach(function (submenu) {
        if (submenu.style.overflow == 'visible') {
          submenu.style.overflow = 'hidden';
        }
        submenu.classList.remove('open');
      });
      var menuItems = document.querySelectorAll('.menu__item');
      menuItems.forEach(function (menuItem) {
        menuItem.classList.remove('open');
      });
    });
    for (var i = 0; subToggles.length > i; i++) {
      var toggleButton = subToggles[i];
      toggleButton.addEventListener('click', function (event) {
        var submenu = toggleButton.parentElement.querySelector('.menu__submenu');
        if (this.classList.contains('open')) {
          closeMenu(this);

          // remove these hiding properties when mousing out, so it can be hovered again
          this.addEventListener('mouseout', function () {
            submenu.style.opacity = '';
            submenu.style.transition = '';
            submenu.style.visibility = '';
          });
        } else {
          this.classList.add('open');
          this.parentNode.classList.add('open');
          this.parentNode.parentNode.classList.add('open');
          this.nextElementSibling.style.maxHeight = 'none';
          this.setAttribute('aria-expanded', true);
        }
        if (this.parentNode.parentNode.classList.contains('menu__submenu')) {
          if (this.parentNode.parentNode.style.overflow == 'visible') {
            this.parentNode.parentNode.style.overflow = 'hidden';
          } else {
            this.parentNode.parentNode.style.overflow = 'visible';
          }
        }
        document.getElementById('menu-toggle').style.display = 'none';
        document.getElementById('main-menu-toggle').classList.add('open');

        // Stop the event from bubbling up to the document
        event.stopPropagation();

        // Event listener for clicks anywhere else on the document
        document.addEventListener('click', function (event) {
          // Check if the clicked element is NOT the submenu or the arrow button
          if (!submenu.contains(event.target) && !toggleButton.contains(event.target)) {
            closeMenu(toggleButton); // Close the menu if clicked outside
            console.log('menu closed from document click');
          }
        });
      });
    }
    window.addEventListener('resize', function () {
      if (this.window.innerWidth >= 992) {
        menuToggle.classList.remove('open');
        menuToggle.setAttribute('aria-expanded', false);
        document.getElementById('menu').classList.remove('open');
        document.querySelector('body').classList.remove('opened-menu');
        mainMenuToggle.classList.remove('open');
        document.querySelector('.main-menu .menu').classList.remove('open');
        var toggles = document.querySelectorAll('.main-menu .submenu-toggle.open');
        toggles.forEach(function (element) {
          element.classList.remove('open');
          element.nextElementSibling.style.maxHeight = '0px';
        });
        var submenus = document.querySelectorAll('.menu__submenu');
        submenus.forEach(function (submenu) {
          if (submenu.style.overflow == 'visible') {
            submenu.style.overflow = 'hidden';
          }
          submenu.classList.remove('open');
        });
        var menuItems = document.querySelectorAll('.menu__item');
        menuItems.forEach(function (menuItem) {
          menuItem.classList.remove('open');
        });
      } else {
        if (!mainMenuToggle.classList.contains('open')) {
          menuToggle.style.display = 'block';
        }
      }
    });
  });
})();
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
* This file is loaded asyncronously in the footer.
* All custom global scripts should be included here.
*/

/*
A little info for this js file:
	As much as possible, this file should be kept organized. Currently, two major divisions are seen below, delinitated by their respective functions of "on load" and "ready".
	As mentioned below, most code added to this file should be included within the "on load" function.
	For ease of future use, include any new code at the bottom of the relevant section of the page, adding clear comments to explain the purpose of the code being written,
	including any relavant details regarding what the code overrides, etc.
*/

(function () {
  'use strict';

  // rerun lazyload on screen size updates
  window.addEventListener('resize', function () {
    dbs.lazyload();
  });

  // Load event function ... most custom stuff goes here. Safer for async.
  window.addEventListener('load', function () {
    /* Search Form functionality
     * The click functionality involves three different actions,
     * depending on conditions the various clicks provide.
     */
    var searchOpen = document.querySelectorAll('.search-form__button--open');
    var searchClose = document.querySelectorAll('.search-form__button--close');
    if (searchOpen) {
      for (var i = 0; searchOpen.length > i; i++) {
        searchOpen[i].addEventListener('click', function () {
          this.parentElement.classList.add('search-form--active');
          this.parentElement.querySelector('.site_search__field').focus();

          // Hide the search bar after click out of it
          document.getElementById('content').addEventListener('click', function () {
            if (this.parentElement.classList.contains('search-form--active')) {
              this.parentElement.classList.remove('search-form--active');
            }
          });
        });
      }
      for (var i = 0; searchClose.length > i; i++) {
        searchClose[i].addEventListener('click', function () {
          this.parentElement.classList.remove('search-form--active');
        });
      }
    }

    /**
     * Animated Form Labels
     * 
     * CSS class must be added in GForms admin on each field that will need to animate.
     */
    var animateForm = document.querySelectorAll('.animate-labels');
    if (animateForm) {
      var inputs = document.querySelectorAll('.animate-labels input');
      for (var i = 0; inputs.length > i; i++) {
        var input = inputs[i];
        input.addEventListener('focus', function () {
          if (this.parentElement.classList.contains('ginput_container')) {
            this.parentElement.parentElement.classList.add('active');
          } else {
            this.parentElement.classList.add('active');
          }
        });
        input.addEventListener('blur', function () {
          var $this = this;
          setTimeout(function () {
            if ($this.value == '') {
              $this.parentElement.parentElement.classList.remove('active');
              $this.parentElement.classList.remove('active');
            }
          }, 100);
        });
      }
    }

    /**
     * Linkclicker
     * 
     * A class placed on a wrapping element with a link inside to make the wrapper clickable.
     */
    var linkclickers = document.querySelectorAll('.linkclicker');
    for (var i = 0; linkclickers.length > i; i++) {
      var linkclicker = linkclickers[i];
      linkclicker.addEventListener('click', function (e) {
        e.preventDefault();
        var link = this.querySelector('a:not(.linkclicker-ignore)');
        var linkPath = link.getAttribute('href');
        if (link.getAttribute('target', "_blank")) {
          window.open(linkPath);
        } else {
          window.location.href = linkPath;
        }
      });
    }

    /**
    * Placeholder
    * 
    * Does the same thing as linkclicker except to placeholder images so that they link to their respective posts
    */
    var placeholders = document.querySelectorAll('.placeholder');
    for (var i = 0; placeholders.length > i; i++) {
      var placeholder = placeholders[i];
      placeholder.style.cursor = 'pointer';
      placeholder.addEventListener('click', function (e) {
        e.preventDefault();
        var link = this.parentElement.querySelector('a:not(.linkclicker-ignore');
        var linkPath = link.getAttribute('href');
        if (link.getAttribute('target', "_blank")) {
          window.open(linkPath);
        } else {
          window.location.href = linkPath;
        }
      });
    }

    /**
     * Force external links/PDFs to open in a new tab.
     * From https://stackoverflow.com/questions/2910946/test-if-links-are-external-with-jquery-javascript
     * 2019-07-11 - TA
     */
    function link_is_external(link_element) {
      return link_element.host !== window.location.host || link_element.href.indexOf("pdf") > -1;
    }
    var anchorElements = document.getElementsByTagName('a');
    var _iterator = _createForOfIteratorHelper(anchorElements),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var anchorElement = _step.value;
        if (link_is_external(anchorElement)) {
          anchorElement.setAttribute('target', '_blank');
          anchorElement.setAttribute('rel', 'noopener');

          // Add assistive text to alert of external links
          var assistiveText = '<span class="assistive">. External Link. Opens in new window.</span>';
          var assistiveTextContainer = document.createElement('span');
          assistiveTextContainer.innerHTML = assistiveText;
          anchorElement.appendChild(assistiveTextContainer.firstChild);
        }
      }

      /**
       * Detects if element is in viewport
       * 
       * @usage
       * var el = document.querySelector('.home-panes__line');
       *
       * window.addEventListener('scroll', function(event) {
       * 		if (isInViewport(el)) {
       *			el.classList.add("in-view");
       *		}
       * }, false);
       */
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    function isInViewport(elem) {
      var distance = elem.getBoundingClientRect();
      return distance.top >= 0 && distance.left >= 0 && distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) && distance.right <= (window.innerWidth || document.documentElement.clientWidth);
    }
    ;

    // Hides collapsible content only if JS loads
    var collapsibleContents = document.querySelectorAll('.collapsible-row__content--wrapper');
    collapsibleContents.forEach(function (content) {
      content.classList.add('loaded');
    });
    if (window.jQuery) {
      $('.collapsible-row__header').on('click', function () {
        $(this).parent().toggleClass('expanded');
        $(this).siblings('.collapsible-row__content--wrapper').slideToggle(250);
      });

      // Disable form buttons after first click to prevent duplicate submissions
      $('.gform_wrapper form').submit(function () {
        $(this).find('input[type=submit]').addClass('disabled');
      });
      $('.member').click(function () {
        console.log('foo');
        $(this).next('.member-modal').toggle();
      });

      // Hide the member-modal when the close button is clicked
      $('.member-modal__close').click(function () {
        $(this).closest('.member-modal').hide();
      });
    }
    var videoLayouts = document.querySelectorAll('.layout-video-text');
    if (videoLayouts) {
      var _iterator2 = _createForOfIteratorHelper(videoLayouts),
        _step2;
      try {
        var _loop = function _loop() {
          var videoLayout = _step2.value;
          videoLayout.querySelector(".play-button").addEventListener("click", function (e) {
            // Hide the play button
            e.target.style.display = "none";

            // Hide video image
            videoLayout.querySelectorAll('.video-photo img')[0].style.display = "none";
            // Show video wrapper
            videoLayout.querySelectorAll('.video-photo .layout-video-text__video')[0].style.display = "block";

            // Take element string from data attribute, and insert it as html. This is done
            // to defer the loading of Vimeo's extra crap on page load.
            var src = videoLayout.querySelector('.layout-video-text__video').getAttribute('data-embed');
            var iframe = document.createElement('iframe');
            iframe.setAttribute('src', src + '&autoplay=1');
            iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('width', '640');
            iframe.setAttribute('height', '360');
            videoLayout.querySelectorAll('.video-photo .layout-video-text__video')[0].appendChild(iframe);
            e.preventDefault();
          });
        };
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }

    // hides Amazon pixel so it doesn't create an empty space at the top of each page
    var amazonPixel = document.querySelector('img[src*="star.gif"]');
    //amazonPixel.style.height = '0';
  }); // End of load function

  // Include ready events here
  window.addEventListener('DOMContentLoaded', function () {});

  /**
   * Cookie Popup scripts
   */
  var popUp = document.getElementById('cookie-popup');
  var popUpMain = document.getElementById('popup-main');

  // Hide popup and background filter and set cookie
  function accept() {
    popUp.style.display = "none";
    document.body.classList.add('cookies');
    setCookie("accepts-cookie", "accepts-cookie-set", 365);
  }
  document.getElementById('accept-button').addEventListener('click', function () {
    accept();
  });
  var cookie = readCookie('accepts-cookie');
  // If user already has accepted cookies, don't show popup
  if (cookie == 'accepts-cookie-set') {
    popUp.style.display = "none";
  } else {
    // Force screen reader to read popup
    popUpMain.setAttribute("aria-live", "assertive");
  }
})();